import { Placement } from "./Placement";

export interface IMacro {
    type?: MacroType
    publisherId?: number
    lazyLoad?: boolean
    placements?: Placement[]
}

export class Macro { // implements IMacro {
    public id: number;
    public type: MacroType;
    public publisherId: number;
    public dateCreated: string;
    public macroIdentifier: string;
    public lazyLoad: boolean;
    public placements: Placement[];

    constructor();
    constructor(obj: IMacro)
    constructor(obj?: IMacro) {
        this.type = obj && obj.type || undefined;
        this.publisherId = obj && obj.publisherId || undefined;
        this.lazyLoad = obj && obj.lazyLoad || undefined;
        this.placements = obj && obj.placements || [];
    }
}

export enum MacroType {
    Edge = 1,
    RMB = 2
}
